var _defs, _path, _path2, _path3, _path4, _path5, _polygon, _polygon2, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanorte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 1046 110.8",
    width: 1046,
    height: 110.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs25"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 268.61,45.83 c 0,1.35 0,5.48 -8.59,5.48 h -46.6 V 31.85 H 260 c 8.59,0 8.59,4.12 8.59,5.48 z m -55.19,22.1 H 260 c 4.08,0 6,0.59 6.78,1.07 1.55,1 2.34,3 2.34,6 v 6.77 c 0,3 -0.79,5 -2.31,5.95 -1.23,0.72 -3.53,1.09 -6.81,1.09 h -46.6 z m 64.7,-8.2 c 7.72,-2.19 11.63,-7.26 11.63,-15.12 V 33.69 c 0,-12.14 -7.08,-18.29 -21.06,-18.29 h -77.62 v 91.39 h 72.07 c 18.12,0 27.31,-6.21 27.31,-18.46 V 76.88 c 0,-9 -4.15,-14.75 -12.33,-17.15",
    id: "path2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 381.63,69.18 h -36.07 l 18.36,-33.52 z m -6.4,-53.8 H 354 l -51.7,91.41 h 23 l 10.41,-19.6 h 55.61 l 10.75,19.6 h 25.6 L 375.5,15.87 Z",
    id: "path4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 528.37,63.38 c 0,1.78 0.23,6.1 0.68,12.84 -2.2,-2.28 -5,-4.91 -8.51,-7.83 l -63,-52.75 -0.26,-0.21 H 441.8 v 91.39 h 20.61 V 57.45 c 0,-3.09 -0.2,-7 -0.6,-11.5 a 66.53,66.53 0 0 0 5.65,5.28 l 65.75,55.34 0.27,0.22 H 549 V 15.38 h -20.63 z",
    id: "path6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 664.7,88.09 H 597.87 V 33.24 h 66.83 z m -0.45,-72.71 h -65.93 c -8.88,0 -14.82,1.5 -18.16,4.58 -3.34,3.08 -5,8.84 -5,17.52 v 47.19 c 0,8.69 1.63,14.42 5,17.51 3.37,3.09 9.28,4.59 18.16,4.59 h 65.93 c 8.89,0 14.82,-1.5 18.15,-4.59 3.33,-3.09 5,-8.82 5,-17.51 V 37.5 c 0,-8.68 -1.63,-14.41 -5,-17.52 -3.37,-3.11 -9.27,-4.6 -18.15,-4.6",
    id: "path8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m 736.58,32.54 h 45.89 c 3.82,0 5.55,0.51 6.29,0.92 1.46,0.87 2.17,2.61 2.17,5.3 V 49.6 c 0,2.69 -0.71,4.43 -2.13,5.29 -0.78,0.42 -2.51,0.93 -6.33,0.93 h -45.89 z m 55.29,40.42 c 14,0 21.08,-6.15 21.08,-18.29 v -21 c 0,-12.14 -7.09,-18.29 -21.08,-18.29 h -77.65 v 91.39 h 22.36 V 72.96 H 755 l 35.83,33.58 0.27,0.25 H 824 L 782.67,72.96 Z",
    id: "path10"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "1023.33,603.41 1046.03,603.41 1046.03,529.86 1087.32,529.86 1087.32,512.02 982.21,512.02 982.21,529.86 1023.33,529.86 ",
    id: "polygon12",
    transform: "translate(-152,-496.62)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "1170.41,564.38 1170.41,547.23 1127.97,547.23 1127.97,529.16 1197.13,529.16 1197.13,512.02 1105.27,512.02 1105.27,603.41 1198,603.41 1198,584.71 1127.97,584.71 1127.97,564.38 ",
    id: "polygon14",
    transform: "translate(-152,-496.62)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 74.17,53.88 89.56,11.74 v 42.12 c 2.26,0.07 4.56,0.16 6.86,0.16 42.15,0 76.36,-11.3 76.36,-26.51 C 172.78,12.3 138.57,0 96.42,0 54.27,0 20,12.38 20,27.51 20,39.95 42.87,50.44 74.17,53.88 Z",
    id: "path16"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 73,57.01 C 32.41,57.67 0,69.74 0,84.55 0,96.86 22.51,107.3 53.46,110.8 Z",
    id: "path18"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m 89.61,56.99 v 53.81 c 35.88,-2.25 63.17,-12.68 63.17,-26.25 0,-13.57 -27.29,-25.3 -63.17,-27.56 z",
    id: "path20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanorte);
export default __webpack_public_path__ + "static/media/banorte.a81778f9166a2d5f27519f97126bd88a.svg";
export { ForwardRef as ReactComponent };